import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { capturePostHogPageView } from '../lib/posthog'

function PostHogPageViewTracker() {
  const location = useLocation()

  useEffect(() => {
    capturePostHogPageView(`${location.pathname}${location.search}`)
  }, [location.pathname, location.search])

  return null
}

export default PostHogPageViewTracker
